import React from 'react';
import { RegExTester } from '../components/regex-tester/RegExTester';

export const RegExTesterPage: React.FC = () => {
  return (
    <div className="page-container">
      <RegExTester />
    </div>
  );
};
